import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from 'app/models/user';
import { Team } from 'app/models/team';
import { UserService } from 'app/services/user.service';
import { TeamService } from 'app/services/team.service';
import { Policy } from 'app/models/policy';
import { ActivatedRoute, Router } from '@angular/router';
import { PolicyService } from 'app/services/policy.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';
import { PolicyRulesComponent } from '../policy-rules/policy-rules.component';
import { FormGroup } from '@angular/forms';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { TagService } from 'app/services/tag.service';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { Tag } from 'app/models/tag';
import { WorkflowTemplate } from 'app/models/workflow-template';

@Component({
  selector: 'app-add-custom-policy',
  templateUrl: './add-custom-policy.component.html',
  styleUrls: ['./add-custom-policy.component.scss']
})
export class AddCustomPolicyComponent implements OnInit {

  users: User[];
  teams: Team[];
  tags: Tag[];
  workflows: WorkflowTemplate[];

  currentPolicyFormGroup: FormGroup;
  isLoading: boolean = false;
  isEdit: boolean = false;
  isNgSelectLoading: boolean = false;

  isExternal: boolean = false;

  @ViewChild('permissionsComponent', { static: true }) permissionsComponent: PolicyRulesComponent;

  constructor(private userService: UserService, private teamService: TeamService,
              private activatedRoute: ActivatedRoute, private policyService: PolicyService,
              private toastService: ToastService, private router: Router, private validationHandler: ValidationHandler,
              private workflowTemplateService: WorkflowTemplateService) { 
    this.currentPolicyFormGroup = this.policyService.formGroup();
  }

  ngOnInit(): void {
    this.userService.getAll().subscribe(u => { this.users = u; });
    this.teamService.getAll(false).subscribe(t => this.teams = t);
    this.workflowTemplateService.getAll(true, false).subscribe(w => this.workflows = w);
    this.isEdit = false;
    this.isExternal = !!this.activatedRoute.snapshot.params.external;
    this.currentPolicyFormGroup = this.policyService.formGroup({is_external: this.isExternal} as Policy);


    if (this.activatedRoute.snapshot.params.policyId != 'new') {
      this.isEdit = true;
      this.isLoading = true;
      this.policyService.getById(this.activatedRoute.snapshot.params.policyId).pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe((p) => {
        formGroupPatchValueNullFriendly(this.currentPolicyFormGroup, p);
        this.permissionsComponent.permissions = p.permissions;
      }, () => {
        this.toastService.error('Cannot retrieve policy.');
      });
    }
  }

  onDelete() : void {
    this.isLoading = true;
    this.policyService.deletePolicy(this.currentPolicyFormGroup.value.id).pipe(finalize(() => {
      this.isLoading = false;
    })).subscribe(() => {
      this.router.navigate(['/policies-permissions'], {relativeTo: this.activatedRoute});
    }, () => {
      this.toastService.error('Error deleting policy.');
    });
  }

  onSave() : void {
    this.isLoading = true;
    let policy: Policy = this.currentPolicyFormGroup.value;
    policy.permissions = this.permissionsComponent.permissions;
    this.policyService.putPolicy(policy).pipe(finalize(() => this.isLoading = false)).subscribe(() => {
      this.router.navigate(['/policies-permissions'], {relativeTo: this.activatedRoute});
    }, (err) => {
      if (err && err.errors)
        this.validationHandler.serverValidationHandler(err, this.currentPolicyFormGroup);
      this.toastService.error('Error saving policy.');
    });
  }

  workflowCompareWith(item, selected) {
    return item.name === selected.name;
  }
}
